import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import IconSvg from "../../../SharedComponents/IconSvg";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ApiHelper from "../../../../Helpers/ApiHelper";
import CvNavigateButton from "./CvNavigateButton";
import { useSelector } from "react-redux";
import { folderEnum } from "../../../../Helpers/EnumHelper";
import { useTranslation } from "react-i18next";
import { generateAlert } from "../../../../Helpers/AlertMessagesHelper";
import { UpdateAlertModalData } from "../../../SharedComponents/GeneralModals/Store";

const CvUploadButton = ({ candidateId, cvNavigateIsShown, cvFileName }) => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth?.user);
  const [cvFile, setCvFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const dispatch = useSelector((state) => state.dispatch);

  useEffect(() => {
    if (Boolean(cvFileName)) {
      const backendFileUrl = ApiHelper.cloudFrontURL + folderEnum.cv + cvFileName;
      setPreviewUrl(backendFileUrl);
    } else {
      setPreviewUrl(null);
    }
  }, [cvFileName]);
  useEffect(() => {
    if (Boolean(cvFile)) {
      UpdateCv();
    }
  }, [cvFile]);

  const handleFileSelect = async (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    // Check if file is a PDF
    if (selectedFile.type !== "application/pdf") {
      dispatch(
        UpdateAlertModalData({
          isShown: true,
          header: "cvUploadOnlyPdfFilesCanBeUploaded",
          text: "cvUploadPleaseUploadDotPdfFormat",
        })
      );

      return;
    }

    setCvFile(selectedFile);
    const fileUrl = URL.createObjectURL(selectedFile);
    setPreviewUrl(fileUrl);
    event.target.value = null;
  };

  const UpdateCv = async () => {
    const formData = new FormData();

    formData.append("CandidateId", candidateId);
    if (cvFile) {
      formData.append("CvFile", cvFile);
    }

    ApiHelper.xmlPostFormData("candidate/UpdateCandidateCv", formData, user.token, (res) => {
      if (JSON.parse(res.response).statusCode === 1) {
        generateAlert("success", "Cv yükleme başarılı");
      } else {
        setCvFile(null);
        setPreviewUrl(null);
        dispatch(
          UpdateAlertModalData({
            isShown: true,
            header: "cvUploadUnableToPostCv",
            text: "cvUploadSomethingWentWrong",
          })
        );
      }
    });
  };

  return (
    <>
      <Row>
        {Boolean(cvNavigateIsShown) && (
          <Col xs={"auto"} className={"align-content-center"}>
            <CvNavigateButton
              previewUrl={previewUrl}
              setPreviewUrl={setPreviewUrl}
              setCvFile={setCvFile}
              candidateId={candidateId}
            />
          </Col>
        )}
        <Col xs={"auto"}>
          <input
            id={"cv-upload" + candidateId}
            type="file"
            accept=".pdf"
            style={{ display: "none" }}
            onChange={handleFileSelect}
          />
          <Button
            size={"sm"}
            title={t("cvUploadButtonLabel")}
            className={"button secondary"}
            style={{ height: 46, width: 46, padding: 0 }}
            onClick={() => document.getElementById("cv-upload" + candidateId).click()}
          >
            <IconSvg icon={"upload"} fill={"#0077b6"} />
          </Button>
        </Col>

        {/* Preview PDF Button */}
      </Row>
    </>
  );
};

export default CvUploadButton;
